/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

export * from './components/e-doc-details-dialog/e-doc-details-dialog.component';
export * from './resources/e-doc-details-business.service';
export * from './resources/e-doc-details.model';
